import React, {Component} from 'react';
import './style.scss';
import {Card, CardBody, CardHeader, Col, Collapse, Label, Row} from "reactstrap";
import TxtLbl from "../../../components/Input/Input/TxtLbl";
import DrpDwn from "../../../components/Dropdown/Dropdown/DrpDwn";
import Lbl from "../../../components/Label/Lbl";
import {Button, Form, Icon, Input} from "semantic-ui-react";
import ImageUpload from "../../../components/ImageUploader/ImageUploader";
import * as actionCreator from "../../../store/Action";
import {connect} from "react-redux";
import * as common from "../../../const/Common/CommonFunc";
import * as EmailValidator from "email-validator";
import * as validator from "../../../util/Validator";
import swal from "sweetalert";
// import are_you_sure_icon from "../../assets/img/sweet/question.svg";
import axiosTags from "../../../axios/axios_tag";
import axiosEventTags from "../../../axios/axios_eventtag";
import apiConfig from "../../../axios/axios_api_services";
import {MDBModal} from "mdbreact";
import axios from "../../../axios/axios_authorization";
import st_Img from "../../../assets/img/logos/smarttags_logo.png";
import * as DropDownConst from "../../../store/Reducer/DropDownConst";
import * as Validator from "../../../util/Validator";
import OtpInput from "react-otp-input";
import are_you_sure_icon from "../../../assets/img/sweet/question.svg";
import axiosAuth from "../../../axios/axios_authorization";
import Cookies from "js-cookie";
import * as util from "../../../util/Validator";
import Countdown from "react-countdown";
import VisitorPhotoUpload from "../../../components/VisitorPhotoUpload/VisitorPhotoUpload";
import VisitorPhotoUploadWithFR from "../../../components/VisitorPhotoUpload/VisitorPhotoUploadWithFR";
import StaticEventView from "./static-event-view";
import * as keys from '../../../const/key/Key'
import {PUBLIC_WEB_SIGN_IN_PAGE} from "../../../const/route/Route";
import usrProPic from "../../../assets/img/usr.png";
import QRCode from 'qrcode';
import visitortag_logo from "../../../assets/img/logos/visitor_logo.png";

class App extends Component {
  state = {
    formData: {
      profile_pic: {value: ""},
      userId: {value:0},
      title: {value: ''},
      firstName: {value: ''},
      lastName: {value: ''},
      gender: {value: ''},
      corporateEmail: {value: ''},
      email: {value: ''},
      mobileNo: {value: ''},
      identificationType: {value: ''},
      identificationValue: {value: ''},
      empId: {value: ''},
      staffId: {value: ''},
      addressId: {value: ''},
      address_line_1: {value: ''},
      address_line_2: {value: ''},
      country: {value: 'Sri Lanka'},
      province_state: {value: ''},
      district: {value: ''},
      city_town: {value: ''},
      zip: {value: ''},
    },
    initialPersonalEmail:'',
    initialCorporateEmail:'',
    formValidate: false,
    isEmailChange: false,
    isPersonalEmailChange: false,
    isCorporateEmailChange: false,
    isBothEmailChange: false,
    personalEmailOTP: '',
    corporateEmailOTP: '',
    date: Date.now() + 300000,
    hasCorporateCode: false, isStaticEvent: true, hasEventQR: false,
    loaded: false,
    isJoin: false,qrImg:null,isProPic: false
  };

  componentDidMount() {
    // let eventId = sessionStorage.getItem(keys.SUB_EVENT_QR_UUID)
    // if (eventId) {
    //   this.setState({hasEventQR: true})
    // }
    this.getUser();
  }

  getUser = () => {
    // let abc = {
    //   "success": true,
    //   "user": {
    //     "userId": 94813,
    //     "title": "Mr",
    //     "firstName": "Tharindu",
    //     "lastName": "Athukorala",
    //     "email": "tharinduathukorala1@gmail.com",
    //     "mobile": "94778533935",
    //     "birthday": "1996-09-19",
    //     "profile_pic": null,
    //     "gender": "Male",
    //     "identification_type": "NIC",
    //     "identification_value": "962631444V",
    //     "temporary_identification_type": "NIC",
    //     "temporary_identification_value": "962631444V",
    //     "address": {
    //       "addressId": 0,
    //       "line1": null,
    //       "line2": null,
    //       "city": null,
    //       "district": null,
    //       "province": null,
    //       "postalCode": null,
    //       "country": null,
    //       "status": 0,
    //       "createdDate": "2024-04-30T13:05:38.084+0530",
    //       "modifyDate": null,
    //       "modifyBy": null
    //     },
    //     "corporateName": "Ceyentra Technologies",
    //     "designation": null,
    //     "department": null,
    //     "companyName": "Ceyentra Technologies",
    //     "corporateLogo": "https://resources.tags.lk/tags/corporate/images/c1353265-c7dd-4a72-81c9-12621ddf2125.png",
    //     "staffId": "staff_0010-",
    //     "empId": "staff_0010_emp",
    //     "corporateCode": "C001",
    //     "corporateEmail": null
    //   }
    // };
    // this.setState({hasCorporateCode: (!(abc.user.corporateCode === null || abc.user.corporateCode === ""))});
    // this.setData(abc.user);
    // return;

    this.props.spinnerHandler(true);
    const headers = {"Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")}
    axiosTags.get(apiConfig.GUEST_VIEW_USER_PROFILE,{headers:headers})
      .then(response => {
        if (response.data.success){
          this.props.spinnerHandler(false);
          this.setState({hasCorporateCode: (!(response.data.user.corporateCode === null || response.data.user.corporateCode === ""))});
          this.setData(response.data.user);
        }
      })
      .catch(error => {
        this.props.spinnerHandler(false);
        if (error.status === 403) {
          common.notifyMessage(error.statusDesc, 0, 3);
        } else if (error.response.status === 401) {
          this.props.history.push(PUBLIC_WEB_SIGN_IN_PAGE);
        } else {
          common.notifyMessage("Something went wrong!", 0, 3);
        }
      })
  }

  setData = (userObj) => {
    if(userObj.mobile) this.generateQR(userObj.mobile);
    this.setState({
      formData: {
        profile_pic: {value: userObj.profile_pic? userObj.profile_pic : ""},
        userId: {value: userObj.userId},
        title: {value: userObj.title === null ? "" : userObj.title },
        firstName: {value: userObj.firstName === null ? "" : userObj.firstName},
        lastName: {value: userObj.lastName === null ? "" : userObj.lastName },
        gender: {value: userObj.gender === null ? "" : userObj.gender },
        corporateEmail: {value: userObj.corporateEmail === null ? "" : userObj.corporateEmail},
        email: {value: userObj.email === null ? "" : userObj.email},
        mobileNo: {value: userObj.mobile === null ? "" : userObj.mobile.startsWith("94") ? userObj.mobile.substr(2) : userObj.mobile},
        identificationType: {value: userObj.identification_type === null ? "" : userObj.identification_type},
        identificationValue: {value: userObj.identification_value === null ? "" : userObj.identification_value},
        empId: {value: userObj.empId === null ? "" : userObj.empId},
        staffId: {value: userObj.staffId === null ? "" : userObj.staffId},
        addressId: {value: userObj.address.addressId},
        address_line_1: {value: userObj.address.line1 === null ? "" : userObj.address.line1},
        address_line_2: {value: userObj.address.line2 === null ? "" : userObj.address.line2},
        country: {value: userObj.address.country === null ? "" : userObj.address.country},
        province_state: {value: userObj.address.province === null ? "" : userObj.address.province },
        district: {value: userObj.address.district === null ? "" : userObj.address.district },
        city_town: {value: userObj.address.city === null ? "" : userObj.address.city },
        zip: {value: userObj.address.postalCode === null ? "" : userObj.address.postalCode },
      },
      initialPersonalEmail:userObj.email === null ? "" : userObj.email,
      initialCorporateEmail:userObj.corporateEmail === null ? "" : userObj.corporateEmail,
      loaded: true, isProPic: false
    })
    let eventId = sessionStorage.getItem(keys.SUB_EVENT_QR_UUID)
    if (eventId) this.setState({isStaticEvent: true, hasEventQR: true})
  }

  // componentWillUnmount() {
  //   // clearInterval(this.timer)
  // }
  generateQR = (mobile) => {
      QRCode.toDataURL(mobile.toString(),{ scale: 10 })
        .then(url => {
          this.setState({qrImg: url});
        })
        .catch(err => {
          console.error(err)
        })
  };
  dropDownChange = name => (event, {value}) => {
    const formData = {
      ...this.state.formData
    };
    formData[name].value = value;
    formData[name].valid = true;

    this.setState({
      formData: formData
    });

    let formValid = true;
    for (let inputIdentifier in formData) {
      formValid = formData[inputIdentifier].valid && formValid
    }

    this.setState({
      formValidate: formValid
    });

  };

  handleChange = (name, length) => event => {
    let value = '';

    if (name === "mobileNo" || name === "emgMobileNo") {
      let reg = /^\d+$/;
      if (reg.test(event.target.value) || event.target.value === "") {
        value = event.target.value;
      }
    } else {
      value = event.target.value;
    }

    const valid = Validator.textFieldValidator(value, length);

    const formData = {
      ...this.state.formData
    };
    formData[name].value = value;
    formData[name].valid = valid;

    this.setState({
      formData: formData
    });

    let formValid = true;
    for (let inputIdentifier in formData) {
      formValid = formData[inputIdentifier].valid && formValid
    }

    this.setState({
      formValidate: formValid
    });
  };

  refreshPage = (value) => {
    if(value !== "NONE"){
      // this.signOutHandler();
    } else{
      let eventId = sessionStorage.getItem(keys.SUB_EVENT_QR_UUID)
      this.setState({hasEventQR: !!eventId})
    }
  }

  onPersonalEmailOTPChangeHandler = (otp) => {
    this.setState({personalEmailOTP:otp});
  }

  onCorporateEmailOTPChangeHandler = (otp) => {
    this.setState({corporateEmailOTP:otp});
  }

  verifyAndUpdateUser = () => {
    const obj = JSON.stringify({
      userId: this.state.formData.userId.value,
      firstName: this.state.formData.firstName.value,
      lastName: this.state.formData.lastName.value,
      title: this.state.formData.title.value,
      gender: this.state.formData.gender.value? this.state.formData.gender.value : null,
      identificationType: this.state.formData.identificationType.value,
      identificationValue: this.state.formData.identificationValue.value,
      mobile: this.state.formData.mobileNo.value !== "" ? "94" + this.state.formData.mobileNo.value : this.state.formData.mobileNo.value,
      email: this.state.formData.email.value? this.state.formData.email.value : null,
      corporateEmail: this.state.formData.corporateEmail.value? this.state.formData.corporateEmail.value : null,
      emailOTP: this.state.personalEmailOTP? this.state.personalEmailOTP : null,
      corporateEmailOTP: this.state.corporateEmailOTP? this.state.corporateEmailOTP : null,
      // userRole: "MOBILE_USER",
      profilePic: this.state.formData.profile_pic.value,
      empId: this.state.formData.empId.value? this.state.formData.empId.value : null,
      staffId: this.state.formData.staffId.value? this.state.formData.staffId.value : null,
      addressEntities: [
        {
          addressId: this.state.formData.addressId.value,
          line1: this.state.formData.address_line_1.value,
          line2: this.state.formData.address_line_2.value,
          city: this.state.formData.city_town.value,
          district: this.state.formData.district.value,
          province: this.state.formData.province_state.value,
          postalCode: this.state.formData.zip.value
        }
      ]
    });

    this.props.spinnerHandler(true);
    const headers = {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    axiosTags.post(apiConfig.UPDATE_PUBLIC_USERS, obj, {headers: headers})
      .then(response => {
        if (response.data.success) {
          common.warningAlert(response.data.message, 0);
          this.setState({isEmailChange: false,personalEmailOTP: '',corporateEmailOTP:'',isPersonalEmailChange: false,isCorporateEmailChange: false,isBothEmailChange: false});
          this.getUser();
          window.scrollTo(0,0);
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          // this.updateUserHandle()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  }

  checkEmailExists = async () => {
    if (this.state.isBothEmailChange) {
      await this.checkBothEmailsExists(this.state.formData.email.value,this.state.formData.corporateEmail.value);
    } else if (this.state.isPersonalEmailChange) {
      await this.checkPersonalOrCorporateEmailExists(this.state.formData.email.value,"personal");
    } else if (this.state.isCorporateEmailChange) {
      await this.checkPersonalOrCorporateEmailExists(this.state.formData.corporateEmail.value,"corporate");
    }
  }

  checkPersonalOrCorporateEmailExists = async (email,type) => {
    this.props.spinnerHandler(true);

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    await axiosAuth.get(apiConfig.CHECK_EMAIL_EXIST({
      email: email,
      emailType: type
    }), {headers: headers})
      .then(response => {
        if (response.data) {
          common.warningAlert("User email already exists", 1);
        } else if (response.data.error_code === 402) {
          common.notifyMessage(response.data.message);
        } else {
          this.onSendOTPToPersonalOrCorporateEmailHandler(email,type);
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          common.notifyMessage("Something went wrong")
        }
      })
      .finally(fin => {
          this.props.spinnerHandler(false);
      });
  }

  checkBothEmailsExists= async (personalEmail,corporateEmail) => {
    this.props.spinnerHandler(true);

    const obj = JSON.stringify({
      email: personalEmail,
      corporateEmail: corporateEmail
    });

    const headers = {
      'Content-Type': 'application/json',
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    await axiosAuth.post(apiConfig.CHECK_BOTH_EMAIL_EXIST,obj,{headers:headers})
      .then(response => {
        if (response.data.status) {
          common.warningAlert(response.data.message, 1);
        } else {
          this.onSendOTPToBothEmailHandler(this.state.formData.email.value,this.state.formData.corporateEmail.value);
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          common.notifyMessage("Something went wrong")
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  }

  onSendOTPToPersonalOrCorporateEmailHandler = (email,type) => {
    const emailObj = JSON.stringify({
      email: email,
      emailType: type
    })

    this.props.spinnerHandler(true);

    const headers = {
      'Content-Type': 'application/json'
    }

    axiosAuth.post(apiConfig.GUEST_USER_SEND_OTP,emailObj,{headers:headers})
      .then(response => {
        if (response.data.success) {
          this.props.spinnerHandler(true);
          this.setState({
            date: Date.now() + 300000,
            isEmailChange: true
          })
        } else {
          common.warningAlert(response.data.message, 1)
          this.setState({
            isEmailChange: true
          })
        }
      })
      .catch(error => {
        common.checkErrorResponse(error);
      })
      .finally(fin => {
          this.props.spinnerHandler(false);
      })
  }

  onSendOTPToBothEmailHandler = (personalEmail,corporateEmail) => {
    const obj = JSON.stringify({
      email: personalEmail,
      corporateEmail: corporateEmail
    })

    this.props.spinnerHandler(true);

    const headers = {
      'Content-Type': 'application/json'
    }

    axiosAuth.post(apiConfig.SEND_OTP_TO_BOTH_EMAILS,obj,{headers:headers})
      .then(response => {
        if (response.data.success) {
          this.props.spinnerHandler(true);
          this.setState({
            date: Date.now() + 300000,
            isEmailChange: true
          })
        } else {
          common.warningAlert(response.data.message, 1)
          this.setState({
            isEmailChange: true
          })
        }
      })
      .catch(error => {
        common.checkErrorResponse(error);
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      })
  }

  emailInputChangeHandler = (status) => {
    let {email,corporateEmail} = this.state.formData;
    if (this.state.initialPersonalEmail.trim() !== email.value.trim() && this.state.initialCorporateEmail.trim() !== corporateEmail.value.trim() && corporateEmail.value !== "") {
      this.setState({isPersonalEmailChange: false, isCorporateEmailChange: false, isBothEmailChange: true},() => {
        this.validationHandler(status);
      });
    } else if (this.state.initialPersonalEmail.trim() !== email.value.trim()) {
      this.setState({isPersonalEmailChange: true,isCorporateEmailChange: false, isBothEmailChange: false},() => {
        this.validationHandler(status);
      });
    } else if (this.state.initialCorporateEmail.trim() !== corporateEmail.value.trim()) {
      if(corporateEmail.value !== "") {
        this.setState({isPersonalEmailChange: false,isCorporateEmailChange: true, isBothEmailChange: false},() => {
          this.validationHandler(status);
        });
      } else {
        this.setState({isPersonalEmailChange: false,isCorporateEmailChange: false, isBothEmailChange: false},() => {
          this.validationHandler(status);
        });
      }
    } else {
      this.validationHandler(status);
    }
  }

  validationHandler = (status) => {
    let {title,firstName,lastName,corporateEmail,email,mobileNo,identificationType,identificationValue} = this.state.formData;
    let {isPersonalEmailChange,isCorporateEmailChange,isBothEmailChange,initialPersonalEmail,initialCorporateEmail} = this.state;

    let isValid = false;
    if (identificationValue.value !== "" ) {
      isValid = validator.identityValueValidator(identificationValue.value, identificationType.value);
      if (!isValid) {
        return;
      }
    }

    if (corporateEmail.value.trim() !== "") {
      if (!EmailValidator.validate(corporateEmail.value)) {
        common.notifyMessage("Please enter valid email");
        return;
      }
    }

    title.value.trim() === "" ? common.notifyMessage("User title cannot be empty") :
      firstName.value.trim() === "" ? common.notifyMessage("User first name cannot be empty") :
        lastName.value.trim() === "" ? common.notifyMessage("User last name cannot be empty") :
          email.value.trim() === "" ? common.notifyMessage("Personal email cannot be empty") :
            !EmailValidator.validate(email.value) ? common.notifyMessage("Please enter valid email") :
              mobileNo.value.trim() === "" ? common.notifyMessage("User mobile number cannot be empty") :
                identificationType.value === "" ? common.notifyMessage("Please select identification type") :
                  identificationValue.value.trim() === "" ? common.notifyMessage("User identification value cannot be empty") :
                     initialPersonalEmail.trim() !== email.value && initialCorporateEmail.trim() !== corporateEmail.value ? this.checkEmailExists() :
                      initialPersonalEmail.trim() !== email.value ? this.checkEmailExists() :
                        initialCorporateEmail.trim() !== corporateEmail.value && corporateEmail.value !== "" ? this.checkEmailExists() :
                          status === -1 ? this.verifyAndUpdateUser() :
                    swal({
                      title: "Are you sure do you want to update this user?",
                      icon: are_you_sure_icon,
                      closeOnClickOutside: false,
                      buttons: {
                        cancel: 'Cancel',
                        dangerMode: {
                          text: "Yes",
                          value: "action",
                          className: "okay-btn"
                        }
                      },
                    }).then((value) => {
                      switch (value) {
                        case "action":
                          this.verifyAndUpdateUser();
                          break;
                        default:
                          break;
                      }
                    })
  }

  verifyOTP = () => {
    let {isPersonalEmailChange,isCorporateEmailChange,isBothEmailChange,personalEmailOTP,corporateEmailOTP} = this.state;


    isPersonalEmailChange && personalEmailOTP === "" ? common.notifyMessage("Please enter OTP number") :
      isCorporateEmailChange && corporateEmailOTP === "" ? common.notifyMessage("Please enter OTP number") :
        isBothEmailChange && (personalEmailOTP === "" || corporateEmailOTP === "") ? common.notifyMessage("Please enter both OTP numbers") :
    swal({
      title: "Are you sure do you want to update this user?",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {
        cancel: 'Cancel',
        dangerMode: {
          text: "Yes",
          value: "action",
          className: "okay-btn"
        }
      },
    }).then((value) => {
      switch (value) {
        case "action":
          this.verifyAndUpdateUser();
          break;
        default:
          break;
      }
    })
  }

  renderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      return <label className={'resend-text'} onClick={() => {
        if (this.state.isBothEmailChange) {
          this.onSendOTPToBothEmailHandler(this.state.formData.email.value,this.state.formData.corporateEmail.value);
        } else if (this.state.isPersonalEmailChange) {
          this.onSendOTPToPersonalOrCorporateEmailHandler(this.state.formData.email.value,"personal");
        } else if (this.state.isCorporateEmailChange) {
          this.onSendOTPToPersonalOrCorporateEmailHandler(this.state.formData.corporateEmail.value,"corporate");
        }
      }}>Resend</label>;
    } else {
      return <label>{minutes > 9 ? minutes : `0${minutes}`}:{seconds > 9 ? seconds : `0${seconds}`}</label>;
    }
  }

  backToLoginHandler = () => {
    swal({
      title: "Do you want to sign out?",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {
        cancel: 'Cancel',
        dangerMode: {
          text: "Yes",
          value: "action",
          className: "okay-btn"
        }
      },
    }).then((value) => {
      switch (value) {
        case "action":
          this.signOutHandler(1)
          break;
        default:
          break;
      }
    })
  }

  signOutHandler = (status) => {
    if(status === 1) Cookies.remove('68a6102f6ed24899420170004a0273b8');
    if(status === 1) Cookies.remove('9b8558ba3f051677daf36ebfc67f29fa');
    if(status === 1) sessionStorage.removeItem(keys.SUB_EVENT_QR_UUID);
    this.props.history.push('/user/web-sign-in');
  }

  screenshotHandler = async (screenshot) => {
    const formData = {
      ...this.state.formData
    };
    formData["profile_pic"].value = screenshot;
    await this.setState({formData, isProPic: false})
    this.emailInputChangeHandler(-1);
  }

  render() {

    let {date,isPersonalEmailChange,isCorporateEmailChange,isBothEmailChange,isEmailChange,hasCorporateCode, isStaticEvent, formData,loaded, qrImg, isProPic} = this.state;
    let subEventQRUUID = sessionStorage.getItem(keys.SUB_EVENT_QR_UUID);
    return (
      <div className={"public-corp-reg-form"}>
        { !isStaticEvent ? <Row className={"corp-reg-form "}>
            <Col xs={12} className={'d-flex align-items-center justify-content-between'} style={{backgroundColor:'#f0f3f5',padding:'10px'}}>
              <div className={'d-flex align-items-center'}>
                <div className={"corp-reg-img mr-3"}>
                  <img src={formData?.profile_pic?.value ? formData?.profile_pic?.value : usrProPic} alt={"."} onClick={()=>this.setState({isProPic:true})} className={'img-clickable'}/>
                </div>
                <h4 className={"update-form-main-topic"}>Profile Details</h4>
              </div>
              <div className={"corp-reg-img"}>
                <img src={st_Img} alt={"."}/>
              </div>
            </Col>

            <Col xs="12" lg={"6"} md={"6"} className={"padd_grap"}>
              <CardBody className={'cardBody_left'}>
                <Row>
                  {isProPic ? <Col lg={12} className={"text-align-path col_gap"}>
                    <Button className={'close-btn-pp'} onClick={()=>this.setState({isProPic: false})}>
                      <Icon name='close'/>
                    </Button>
                    <Lbl>Profile Picture</Lbl>
                    {/*<VisitorPhotoUpload screenshotHandler={this.screenshotHandler} screenshot={this.state.formData.profile_pic.value} style={{width: '250px'}}/>*/}
                    {loaded && <VisitorPhotoUploadWithFR defaultOpen={true} screenshotHandler={this.screenshotHandler} screenshot_={this.state.formData.profile_pic.value} style={{width: '250px'}}/>}
                  </Col>:<Col md={12} className={'mobile-qr-code text-center'}>
                    <img src={qrImg} alt={'qr-code'} className={'mb-2'} />
                  </Col>}
                </Row>
                  <Form>
                  <Form.Group widths='equal'>
                    <DrpDwn
                      required
                      tagText={"Title"}
                      placeholder={"Title"}
                      options={DropDownConst.userTitle}
                      value={this.state.formData.title.value}
                      onChange={this.dropDownChange('title')}
                    />
                    <DrpDwn
                      //required
                      tagText={"Gender"}
                      placeholder={"Gender"}
                      options={DropDownConst.gender}
                      value={this.state.formData.gender.value}
                      onChange={this.dropDownChange('gender')}
                    />
                  </Form.Group>
                </Form>
                <Form>
                  <Form.Group widths='equal'>
                    <TxtLbl
                      required
                      tagText={"First Name"}
                      placeholder={"First Name"}
                      value={this.state.formData.firstName.value}
                      onChange={this.handleChange('firstName', 1)}
                    />
                    <TxtLbl
                      required
                      tagText={"Last Name"}
                      placeholder={"Last Name"}
                      value={this.state.formData.lastName.value}
                      onChange={this.handleChange('lastName', 1)}
                    />
                  </Form.Group>
                </Form>
                <Form>
                  <Form.Group widths='equal'>
                    <TxtLbl
                      required
                      tagText={"Personal Email"}
                      placeholder={"Personal Email Address"}
                      value={this.state.formData.email.value}
                      onChange={this.handleChange('email', 1)}
                    />
                  </Form.Group>
                  <Form.Group widths='equal'>
                    <TxtLbl
                      tagText={"Corporate Email"}
                      placeholder={"Company Email Address"}
                      value={this.state.formData.corporateEmail.value}
                      onChange={this.handleChange('corporateEmail', 1)}
                    />
                  </Form.Group>
                  {hasCorporateCode && <Form.Group widths='equal'>
                    <DrpDwn
                      required
                      tagText={"Identification Type"}
                      placeholder={"Identification Type"}
                      options={DropDownConst.Identifications}
                      value={this.state.formData.identificationType.value}
                      onChange={this.dropDownChange('identificationType')}
                    />
                  </Form.Group>}
                  {hasCorporateCode && <Form.Group widths='equal'>
                    <TxtLbl
                      required
                      tagText={"Identification Value"}
                      placeholder={"Identification Value"}
                      value={this.state.formData.identificationValue.value}
                      onChange={this.handleChange('identificationValue', 1)}
                    />
                  </Form.Group>}
                  {!hasCorporateCode && <Form.Group widths='equal'>
                    <TxtLbl
                      disable={true}
                      className={'mobile_field'}
                      tagText={"Mobile Number"}
                      placeholder={"Mobile Number"}
                      value={this.state.formData.mobileNo.value}
                      onChange={this.handleChange('mobileNo', 1)}
                    />
                  </Form.Group>}
                </Form>
              </CardBody>
            </Col>
            <Col xs="12" lg={"6"} md={"6"} className={"padd_grap pb-15"}>
              <CardBody className={'cardBody_right'}>
                <Form>
                  {!hasCorporateCode && <Form.Group widths='equal'>
                    <DrpDwn
                      required
                      tagText={"Identification Type"}
                      placeholder={"Identification Type"}
                      options={DropDownConst.Identifications}
                      value={this.state.formData.identificationType.value}
                      onChange={this.dropDownChange('identificationType')}
                    />
                  </Form.Group>}
                  {!hasCorporateCode && <Form.Group widths='equal'>
                    <TxtLbl
                      required
                      tagText={"Identification Value"}
                      placeholder={"Identification Value"}
                      value={this.state.formData.identificationValue.value}
                      onChange={this.handleChange('identificationValue', 1)}
                    />
                  </Form.Group>}
                  {hasCorporateCode && <Form.Group widths='equal'>
                    <TxtLbl
                      disable={true}
                      className={'mobile_field'}
                      tagText={"Mobile Number"}
                      placeholder={"Mobile Number"}
                      value={this.state.formData.mobileNo.value}
                      onChange={this.handleChange('mobileNo', 1)}
                    />
                  </Form.Group>}
                  {hasCorporateCode && <Form.Group widths='equal'>
                    <TxtLbl
                      //required
                      tagText={"Employee ID"}
                      placeholder={"Employee ID"}
                      value={this.state.formData.empId.value}
                      onChange={this.handleChange('empId', 1)}
                    />
                  </Form.Group>}
                  {hasCorporateCode && <Form.Group widths='equal'>
                    <TxtLbl
                      tagText={"Staff ID"}
                      placeholder={"Staff ID"}
                      value={this.state.formData.staffId.value}
                      onChange={this.handleChange('staffId', 1)}
                    />
                  </Form.Group>}
                  <Form.Group widths='equal'>
                    <TxtLbl
                      //required
                      tagText={"Address Line 1"}
                      placeholder={"Address Line 1"}
                      value={this.state.formData.address_line_1.value}
                      onChange={this.handleChange('address_line_1', 1)}
                    />
                  </Form.Group>
                  <Form.Group widths='equal'>
                    <TxtLbl
                      tagText={"Address Line 2"}
                      placeholder={"Address Line 2"}
                      value={this.state.formData.address_line_2.value}
                      onChange={this.handleChange('address_line_2', 1)}
                    />
                  </Form.Group>
                  <Form.Group widths='equal'>
                    <DrpDwn
                      //required
                      tagText={"Province/State"}
                      placeholder={"Province/State"}
                      value={this.state.formData.province_state.value}
                      options={DropDownConst.provinces}
                      onChange={this.dropDownChange('province_state')}
                    />
                  </Form.Group>
                  <Form.Group widths='equal'>
                    <DrpDwn
                      //required
                      tagText={"District"}
                      placeholder={"Select district"}
                      value={this.state.formData.district.value}
                      options={DropDownConst.districs}
                      onChange={this.dropDownChange('district')}
                    />
                  </Form.Group>
                  <Form.Group widths='equal'>
                    <TxtLbl
                      //required
                      tagText={"City/Town"}
                      placeholder={"City/Town"}
                      value={this.state.formData.city_town.value}
                      onChange={this.handleChange('city_town', 1)}
                    />
                  </Form.Group>
                  <Form.Group widths='equal'>
                    <TxtLbl
                      tagText={"Zip Code"}
                      placeholder={"Zip code"}
                      value={this.state.formData.zip.value}
                      onChange={this.handleChange('zip', 1)}
                    />
                  </Form.Group>
                </Form>
              </CardBody>
            </Col>
            <Col lg={"12"} className={"text-align-path bottom-button-a-i bottom-fixed-i"} style={{marginBottom: '15px'}}>
              <Button className={'backToLogin-btn'}  onClick={this.backToLoginHandler}>Back to Login</Button>
              <Button className="submit-btn" onClick={this.emailInputChangeHandler}>Update</Button>
            </Col>
          <Col lg={"12"} className={"text-align-path bottom-button-a-ii bottom-fixed-ii"} style={{marginBottom: '15px', marginTop: '20px'}}>
            <a className={'join-event-a'} onClick={() => this.setState({isStaticEvent: true, isJoin: true})}>Join the Event</a>
          </Col>

        </Row>
         : formData.userId.value ? <StaticEventView refresh={this.refreshPage} closeHandler={() => this.setState({isStaticEvent: false})} userId={formData.userId.value} isJoin={subEventQRUUID ? false : this.state.isJoin}/> : null}
        {
          isEmailChange &&
            <MDBModal isOpen={isEmailChange} toggle={() => {}} size="md" className={"user-verification-modal guest-reg-form"}>
              <h4 className={"reg-form-main-topic"}>Email Verification</h4>
              <Row>
                {isPersonalEmailChange && <Col xs={12}>
                  <p
                    className="warning-muted">{`We've sent a verification code to your ${this.state.formData.email.value} . Please provide it below`}</p>
                </Col>}
                {isCorporateEmailChange && <Col xs={12}>
                  <p
                    className="warning-muted">{`We've sent a verification code to your ${this.state.formData.corporateEmail.value} . Please provide it below`}</p>
                </Col>}
                {isBothEmailChange && <Col xs={12}>
                  <p
                    className="warning-muted">{`We have sent separate verification codes to your personal email (${this.state.formData.email.value}) and company email (${this.state.formData.corporateEmail.value}). Please enter the appropriate code below for each email, to complete the verification process.`}</p>
                </Col>}
                <Col xs={12}>
                  {(isPersonalEmailChange || isCorporateEmailChange) && <div className={"otp-form"}>
                    <Form>
                      <Form.Group widths='equal' className={'align-items-center justify-content-center'}>
                        <OtpInput
                          shouldAutoFocus={true}
                          value={isPersonalEmailChange ? this.state.personalEmailOTP : isCorporateEmailChange ? this.state.corporateEmailOTP : ""}
                          onChange={isPersonalEmailChange ? this.onPersonalEmailOTPChangeHandler : isCorporateEmailChange ? this.onCorporateEmailOTPChangeHandler : null}
                          numInputs={5}
                          inputType={"tel"}
                          inputStyle={{margin: '0 10px 20px', width: '3em'}}
                          containerStyle={{justifyContent: 'center'}}
                          renderInput={(props) => <input {...props} />}
                          // focusStyle={{border: '1px solid #FFAD33!important'}}
                        />
                      </Form.Group>
                    </Form>
                    <p className={"expire-text d-inline"}>Didn't receive the code? </p>
                    <Countdown key={date} date={date} renderer={this.renderer}/>
                  </div>}
                  {isBothEmailChange && <div className={"otp-form"}>
                    <Form>
                      <Lbl>Personal email OTP</Lbl>
                      <Form.Group widths='equal' className={'align-items-center justify-content-center'}>
                        <OtpInput
                          shouldAutoFocus={true}
                          value={this.state.personalEmailOTP}
                          onChange={this.onPersonalEmailOTPChangeHandler}
                          numInputs={5}
                          inputStyle={{margin: '0 10px 20px', width: '3em'}}
                          containerStyle={{justifyContent: 'center'}}
                          // focusStyle={{border: '1px solid #FFAD33!important'}}
                        />
                      </Form.Group>
                      <Lbl>Company email OTP</Lbl>
                      <Form.Group widths='equal' className={'align-items-center justify-content-center'}>
                        <OtpInput
                          shouldAutoFocus={true}
                          value={this.state.corporateEmailOTP}
                          onChange={this.onCorporateEmailOTPChangeHandler}
                          numInputs={5}
                          inputStyle={{margin: '0 10px 20px', width: '3em'}}
                          containerStyle={{justifyContent: 'center'}}
                          // focusStyle={{border: '1px solid #FFAD33!important'}}
                        />
                      </Form.Group>
                    </Form>
                    <p className={"expire-text d-inline"}>Didn't receive the code? </p>
                    <Countdown key={date} date={date} renderer={this.renderer}/>
                  </div>}
                  <p className={"align-right"} style={{color: 'gray', textDecoration: 'underline', cursor: "pointer"}}
                     onClick={() => this.setState({isEmailChange: false, personalEmailOTP: '', corporateEmailOTP: ''})}>Change details</p>
                </Col>
                <Col xs={12}>
                  <Button className="submit-btn" onClick={() => this.verifyOTP()}>Verify & Update</Button>
                </Col>
              </Row>
            </MDBModal>
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  usr_obj: state.userReducer.user,
});


const mapDispatchToProps = (dispatch) => {
  return {
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
